<template>
  <client-only>
    <v-layout
      class="cv-short-view"
      wrap
      :class="{ 'cv-hover': allowEditing ? false : true }"
      @click="selectCVFile"
    >
      <!-- xl10 lg10 md9 sm12 xs12 -->
      <v-flex pa-2>
        <v-layout>
          <v-flex xs1 class="flex-center" text-center>
            <!-- <v-icon class="icon-pdf primary--text" /> -->
            <img :src="require('~/assets/img/doc-icon.svg')" class="icon-pdf" />
          </v-flex>
          <v-flex mr-4>
            <p class="display-18 mb-0 font-weight-medium">{{ cvTitle }}</p>
            <p class="display-14-12 pa-0 mb-0">
              {{ lastUpdated + ' ' + fullDate.toLocaleString('en-GB') }}
            </p>
          </v-flex>

          <v-flex class="flex-center mr-4 text-left">
            <p class="display-18 mb-0">
              <span
                class="pointer d-inline-flex font-weight-medium px-2 display-16"
                @click="fetchUserCV"
              >
                {{ displayFile }}
              </span>

              <label
                v-if="allowEditing"
                class="pointer-underline d-inline-flex px-2"
              >
                {{ editFile }}
                <input
                  v-show="false"
                  id="file"
                  ref="file"
                  type="file"
                  accept=".doc, .docx, .pdf, .rtf"
                  @change="editUsersCV"
                />
              </label>

              <GenericPopup
                v-if="allowEditing"
                class="pointer-underline d-inline-flex px-2"
                :button-text="deleteFile"
                :issue-to-confirm="
                  t('genericPopups.deleteFile.deleteCVFromPersonal')
                "
                :confirm="t('genericPopups.deleteFile.confirm')"
                :abort="t('genericPopups.deleteFile.abort')"
                @confirmed="deleteUsersCV"
              />
            </p>
            <p
              v-if="showCVError"
              class="red--text display-14"
              v-html="cvErrorMsg"
            ></p>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </client-only>
</template>

<script>
import { isNil, has } from 'lodash';
import GenericPopup from '@/components/Dialogs/Generic_Popup/GenericPopup';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import { WATCH_CV, UPDATE_CV, DELETE_CV } from '@/lib/api.js';

export default {
  components: {
    GenericPopup,
  },

  props: ['file', 'userCVs', 'allowEditing'],

  data() {
    return {
      lastUpdated: 'ת.עדכון:',
      displayFile: 'צפייה בקובץ',
      editFile: 'החלף קובץ',
      deleteFile: 'מחק קובץ',
      cvErrorMsg: '',
      showCVError: false,
      newFile: '',
      cvPopup: t('titles.CV_Popup'),
    };
  },

  computed: {
    cvTitle() {
      return this.file ? this.file.Title : '';
    },

    fullDate() {
      return this.file
        ? this.file.UpdateDate.split('T')[0].split('-').reverse().join('.')
        : ''; // split the part that should not be displayed
    },
  },

  methods: {
    async fetchUserCV() {
      await this.$axios
        .get(`${WATCH_CV}/${this.file.Code}`, {
          headers: { responseType: 'blob' },
        })
        .then((res) => {
          const fileLink = document.createElement('a');
          fileLink.href =
            'data:application/octet-stream;base64,' + res.data.FileAsBytes;
          fileLink.setAttribute('download', `${res.data.FileName}`);
          document.body.appendChild(fileLink);
          fileLink.click();
        });
    },

    async editUsersCV() {
      this.$nuxt.$loading.start();
      this.showCVError = false;

      this.newFile = this.$refs.file.files[0];
      /** stop in case file undefined */
      if (isNil(this.newFile)) {
        this.$nuxt.$loading.finish();
        return false;
      }
      /**
       * check file size , 500kb max
       */
      // if (this.newFile.size / 1000 > 4000) {
      //   this.cvErrorMsg = this.cvPopup.CVTooLargeErrorMessage;
      //   this.$nuxt.$loading.finish();
      //   this.showCVError = true;
      //   return false;
      // }
      if (!isNil(this.newFile)) {
        if (
          !/^.*\.(doc|DOC|docx|DOCX|pdf|PDF|rtf|RTF)$/.test(this.newFile.name)
        ) {
          this.cvErrorMsg = t('titles.CV_Popup.CVFileNotSupported', {
            name: this.newFile.name,
          });

          this.$nuxt.$loading.finish();
          this.showCVError = true;
          return false;
        } else if (this.newFile.size / 1000 > 4000) {
          this.cvErrorMsg = t('titles.CV_Popup.CVTooLargeErrorMessage', {
            name: this.newFile.name,
          });

          this.$nuxt.$loading.finish();
          this.showCVError = true;
          return false;
        }
      }

      const formData = new FormData();

      formData.append('file', this.newFile);
      formData.append('cvCode', this.file.Code);

      await this.$axios

        .post(`${UPDATE_CV}/`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        .then((res) => {
          if (res.data.IsError) {
            let value = Object.keys(res.data.Errors)[0];
            throw value;
            // throw res.data.Errors;
          }
        })
        .then(() => {
          this.$auth.fetchUser();
          this.$nuxt.$loading.finish();
        })
        .catch((e) => {
          switch (e) {
            case 'CVFileExists':
              console.log('קובץ קיים');
              this.cvErrorMsg = this.cvPopup.existingCVMsg;
              this.showCVError = true;
              break;
            case 'CVFileCorrupted':
              console.log('CVFileCorrupted');
              this.cvErrorMsg = this.cvPopup.CVFileCorrupted;
              this.showCVError = true;
              break;
            case 'CVFileNeededError':
              console.log('CVFileNeededError');
              this.cvErrorMsg = this.cvPopup.CVFileCorrupted;
              this.showCVError = true;
              break;
            case 'UnsupportedMediaType':
              console.log('UnsupportedMediaType');
              this.cvErrorMsg = t('titles.CV_Popup.CVFileNotSupported', {
                name: this.newFile.name,
              });

              this.showCVError = true;
              break;
            default:
              this.cvErrorMsg = 'שגיאה';
              this.showCVError = true;
              break;
          }

          this.$nuxt.$loading.finish();
        });
    },

    async deleteUsersCV() {
      this.showCVError = false;
      this.$nuxt.$loading.start();
      const temp = this.file.Code;
      await this.$axios
        .delete(`${DELETE_CV}/${temp}`)
        .then((res) => {
          if (res.data.IsError) {
            throw res.data.Errors;
          }
        })
        .then(() => {
          console.log('SUCCESS UPDATING!');
          this.$auth.fetchUser();
          this.$nuxt.$loading.finish();
        })
        .catch((e) => {
          if (has(e, 'CVFileExists')) {
            this.cvErrorMsg = this.cvPopup.existingCVMsg;
          } else {
            this.cvErrorMsg = 'שגיאה';
            this.showCVError = true;
          }
          this.$nuxt.$loading.finish();
        });
    },

    selectCVFile() {
      if (!this.allowEditing) this.$emit('fileSelected', this.file);
    },
  },
};
</script>

<style lang="scss" scoped>
.cv-short-view.cv-hover:hover {
  background-color: $darkGray;
  color: #fff;
}

.cv-short-view {
  min-height: 64px;
  border-radius: 5px;
  border: solid 1px #e4e5e7;
  background-color: $white;
}

.displaySelected.cv-short-view {
  background-color: $darkGray;
  color: #fff;
  font-weight: 100;
}

.icon-pdf {
  max-width: 24px;
  vertical-align: middle;
}

@media only screen and (min-width: 600px) {
  .icon-pdf {
    max-width: 32px;
    vertical-align: middle;
  }
}
</style>
